import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ResourceCategoryAvailability } from '@mews-commander/data-access';

export const splitAvailabilitiesByOverbooking = (
    availabilities: ResourceCategoryAvailability[],
    resourceCategoryId: string,
    requestedAvailability = 1,
    availabilityBlockId?: string
) => {
    const filteredAvailabilities = pipe(
        availabilities,
        array.filter((availability) => availability.resourceCategoryId === resourceCategoryId)
    );

    const mappedAvailability = !availabilityBlockId
        ? filteredAvailabilities
        : filteredAvailabilities.map((availability) => ({
              ...availability,
              blockAdjustmentData: availability.blockAdjustmentData?.filter(
                  (blockData) => availabilityBlockId === blockData.availabilityBlockId
              ),
          }));

    const result = mappedAvailability.reduce(
        (acc, availability) => {
            const willOverbookProperty = availability.value < requestedAvailability;
            const willOverbookBlock = !!(
                availabilityBlockId &&
                (!availability.blockAdjustmentData?.length ||
                    availability.blockAdjustmentData.some(
                        (data) => data.remainingBlockAvailability < requestedAvailability
                    ))
            );

            if (willOverbookProperty) {
                acc.propertyOverbookingAvailabilities.push(availability);
            } else {
                acc.availableAvailabilities.push(availability);
            }

            if (willOverbookBlock) {
                acc.blockOverbookingAvailabilities.push(availability);
            } else {
                acc.blockAvailableAvailabilities.push(availability);
            }

            return acc;
        },
        {
            availableAvailabilities: [] as ResourceCategoryAvailability[],
            blockAvailableAvailabilities: [] as ResourceCategoryAvailability[],
            blockOverbookingAvailabilities: [] as ResourceCategoryAvailability[],
            propertyOverbookingAvailabilities: [] as ResourceCategoryAvailability[],
        }
    );

    return result;
};
